/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // Npm: Apollo client for handling graphql request.

/*
 * GRAPHS
 */
const Index = gql`
  query MyQuery($email: String!, $password: String!) {
    AdminLogin(email: $email, password: $password) {
      message
      status
      token
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
